export type GetTextToAutocomplete = (text: string, trigger: string) => string | null

export const getTextToAutocomplete = (text: string, trigger: string): string | null => {
    if (!text.includes(trigger)) {
        return null
    }

    //We are looking for the last trigger, so we start scanning the text from the end
    for (let i = text.length - 1; i >= 0; i--) {
        if (text.charAt(i) === ' ') {
            return null
        }

        if (text.charAt(i) === trigger) {
            const charBeforeTrigger = text.charAt(i - 1)
            const thereIsSpaceBeforeTrigger = charBeforeTrigger === ' ' || charBeforeTrigger === '\n'
            const triggerIsAtBeginningOfWord = i == 0
            if (thereIsSpaceBeforeTrigger || triggerIsAtBeginningOfWord) {
                break
            } else {
                return null
            }
        }
    }

    const lastTriggerIndex = text.lastIndexOf(trigger)
    const word = text.substring(lastTriggerIndex + 1)
    if (word) {
        return word
    } else {
        return null
    }
}